import React from 'react';
import { faFile } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Box from 'components/Box';
import Text from 'components/Text';

const Attachment = ({ fileName, icon = faFile, onClick, href }) => (
  <a
    target="_blank"
    href={href}
    style={{ display: 'block' }}
    rel="noopener noreferrer"
  >
    <Box b ph={16} pv={8} mb={8} pointer bradius={3} onClick={onClick}>
      <FontAwesomeIcon icon={icon} />
      <Text className="pl8" fs14>
        {fileName}
      </Text>
    </Box>
  </a>
);

export default Attachment;
